module.exports = __webpack_public_path__ + "static/img/aepic-20.855d811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-20.jpg
// module id = QPAx
// module chunks = 52